// extracted by mini-css-extract-plugin
export default {"container":"TodoList_container__DBs2s","list":"TodoList_list__dqQoz"};